<template>
    <div class="alerts">
        <div v-for="(alert, key) in alerts" class="alert" :class="alert.type" v-text="alert.content" :key="key"></div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Alerts",
        computed: {
            ...mapGetters('app', {
                alerts: 'getAlerts',
            })
        }
    }
</script>